export default "__VITE_ASSET__CyLqx9Th__"